// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-a3f498ca]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.menu-switch[data-v-a3f498ca]{height:32px}.menu-switch .label[data-v-a3f498ca]{color:hsla(0,0%,100%,.9);font-size:14px;font-weight:400}.menu-switch .label__circle[data-v-a3f498ca]{background-color:#3d46f5;border-radius:100%;height:4px;width:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
